const selectIsDemo = ({ isDemo }) => isDemo;
const selectIsGreeted = ({ isGreeted }) => isGreeted;
const selectIsSwitching = ({ isSwitching }) => isSwitching;

export { selectIsDemo, selectIsGreeted, selectIsSwitching };
